import React, { useState } from 'react';
import PayrollPositionModal from './PayrollPositionModal';
import { Button } from '../ui-kit';

const StartButton = ({ membershipId, size, label = I18n.t('edit') }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // adding data-bs-dismiss on the button to ensure any modal that the button is
  // contained in is closed. This is to prevent multiple modals to exist on the
  // page at the same time, which causes the payroll form not to work
  return (
    <>
      <Button variant="outline-secondary" size={size} onClick={handleShow} data-bs-dismiss="modal">
        {label}
      </Button>
      {show && <PayrollPositionModal onHide={handleClose} membershipId={membershipId} />}
    </>
  );
};

export default StartButton;
